export default __webpack_public_path__ + "static/media/bd.a47ef0b1.png";